import { useMutation, useQuery } from "@apollo/client";
import React, { useState } from "react";
import { LISTAR_SUBTIPO_EGRESOS } from "../../../graphql/bancos";
import Scrollbar from "../../../components/Scrollbar";
import {
  Button,
  Table,
  TableBody,
  TableCell,
  TablePagination,
  TableRow,
} from "@mui/material";
import MovimientosHeader from "../../../components/TableHeader/MovimientosHeader";
import Iconify from "../../../components/Iconify";
import {
  ELIMINAR_SUBCUENTAEGRESO,
  OBTENER_SUBEGRESOS,
} from "../../../graphql/egresos";
const TABLE_HEADER = [
  { id: "clave", label: "Clave", alignRight: false },
  { id: "descripcion", label: "Subcuenta", alignRight: false },
  { id: "CatEgresosId", label: "Cuenta", alignRight: false },
];

const SubCuentasEgresosTable = ({
  setOpenDialog,
  setBodyDialog,
  setErrorGraph,
  setOpenSnackBar,
}) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const { loading, data, error, refetch } = useQuery(OBTENER_SUBEGRESOS);
  const [eliminarDetalleEgreso] = useMutation(ELIMINAR_SUBCUENTAEGRESO);
  if (loading) {
    return <h1>Cargando Información...</h1>;
  }
  const { obtenerDetalleEgresos } = data;
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };
  const handleEditData = (e) => {
    // setBodyDialog(
    //   <FrmEditarConceptosBanco
    //     setOpenDialog={setOpenDialog}
    //     setErrorGraph={setErrorGraph}
    //     setOpenSnackBar={setOpenSnackBar}
    //     id={e}
    //   />
    // );
    // setOpenDialog(true);
  };

  const handleDeleteRecord = async (e) => {
    try {
      const result = await eliminarDetalleEgreso({
        variables: {
          clave: parseInt(e),
        },
      });
      setOpenSnackBar(true);
      setErrorGraph({
        mensaje: result.data.eliminarDetalleEgreso,
        severity: "success",
      });
      refetch();
    } catch (error) {
      setOpenSnackBar(true);
      setErrorGraph({ mensaje: error.message, severity: "error" });
    }
  };
  return (
    <>
      <Scrollbar>
        <Table>
          <MovimientosHeader headLabel={TABLE_HEADER} />
          <TableBody>
            {obtenerDetalleEgresos
              .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
              .map((row) => {
                const { clave, descripcion, CatEgresosId } = row;
                return (
                  <TableRow hover key={clave} tabIndex={-1}>
                    <TableCell>{clave}</TableCell>
                    <TableCell>{descripcion}</TableCell>
                    <TableCell>{CatEgresosId}</TableCell>
                    <TableCell>
                      <Button
                        value={clave}
                        onClick={(e) => {
                          handleDeleteRecord(clave);
                        }}
                        color="error"
                        startIcon={<Iconify icon="eva:close-outline" />}
                      >
                        Eliminar
                      </Button>
                      {/* <Button
                        value={clave}
                        onClick={(e) => {
                          handleEditData(clave);
                        }}
                        startIcon={<Iconify icon="eva:edit-2-outline" />}
                      >
                        Editar
                      </Button> */}
                      {/* {baja ? (
                       <>
                         <Button
                           color="primary"
                           value={id}
                           startIcon={<Iconify icon="eva:checkmark-outline" />}
                           onClick={(e) => {
                            // handleActiveteRecord(id);
                           }}
                         >
                           Activar
                         </Button>
                        
                       </>
                     ) : (
                       <Button
                         value={id}
                         onClick={(e) => {
                          // handleDeactivateRecord(id);
                         }}
                         color="error"
                         startIcon={<Iconify icon="eva:close-outline" />}
                       >
                         Desactivar
                       </Button>
                     )} */}
                    </TableCell>
                  </TableRow>
                );
              })}
          </TableBody>
        </Table>
      </Scrollbar>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        page={page}
        count={obtenerDetalleEgresos.length}
        rowsPerPage={rowsPerPage}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </>
  );
};

export default SubCuentasEgresosTable;
